import {
  MATCHER_ARRIVAL_HANDOFF,
  MATCHER_ARRIVAL_PARAMS,
  type MatcherAnswers,
} from '@/app/(auth)/sign-up/_utils/matcher-arrival';

const APPLICATION_PATH = '/application';
const PAYMENT_PATH = '/payment';

/**
 * Where sign-up sends a learner who picked an externship before having an account.
 *
 * Sign-up only honours `redirect_url`, and every new account must pass through `/application`
 * before the paywall. So the externship rides as the application's own `redirect_url`, which
 * `resolveApplicationSuccessDestination` forwards to `/payment?externshipId=` once it is submitted.
 *
 * A homepage-matcher arrival also carries its three answers (`focus`, `goal`, `stage`, as the short
 * codes the matcher already uses). The application reads them back and, when all three are there,
 * skips straight to the one question the matcher did not ask (see `matcher-express.ts`). Codes only,
 * never labels: the URL survives the Google round trip and lands in access logs.
 */
export function applicationRedirectUrl(externshipId: number, matcherAnswers?: MatcherAnswers): string {
  const paymentParams = new URLSearchParams({ externshipId: String(externshipId) });
  const applicationParams = new URLSearchParams();

  if (matcherAnswers && (matcherAnswers.focus.length > 0 || matcherAnswers.goal.length > 0 || matcherAnswers.stage)) {
    applicationParams.set(MATCHER_ARRIVAL_PARAMS.handoff, MATCHER_ARRIVAL_HANDOFF);
    if (matcherAnswers.focus.length > 0) {
      applicationParams.set(MATCHER_ARRIVAL_PARAMS.focus, matcherAnswers.focus.join(','));
    }
    if (matcherAnswers.goal.length > 0) {
      applicationParams.set(MATCHER_ARRIVAL_PARAMS.goal, matcherAnswers.goal.join(','));
    }
    if (matcherAnswers.stage) {
      applicationParams.set(MATCHER_ARRIVAL_PARAMS.stage, matcherAnswers.stage);
    }
  }

  applicationParams.set('redirect_url', `${PAYMENT_PATH}?${paymentParams.toString()}`);
  return `${APPLICATION_PATH}?${applicationParams.toString()}`;
}
